import rt from "aldoo-ra/Realtime";
import PubSub from "pubsub-js";

let instance = null;

class KPIRealtimeController {
    constructor() {
        this.socket = null;
        this.connected = false;
        this.subscriptions = new Set();
    }

    initialize() {
        if (this.socket) return;
        this.socket = rt("kpi");

        this.socket.on("connect", () => {
            this.connected = true;
            PubSub.publish("kpi:connection_change", { connected: true });
            for (const key of this.subscriptions) {
                this.socket.emit("kpi:subscribe", key);
            }
        });

        this.socket.on("disconnect", () => {
            this.connected = false;
            PubSub.publish("kpi:connection_change", { connected: false });
        });

        this.socket.on("kpi:new_event", (event) => {
            const appId = event.appId || "";
            PubSub.publish(`kpi:event:${event.kpi}:${appId}`, event);
            PubSub.publish(`kpi:event:${event.kpi}:`, event);
        });
    }

    subscribe(kpi, appId) {
        const key = { kpi, appId };
        this.subscriptions.add(key);
        if (this.connected) {
            this.socket.emit("kpi:subscribe", key);
        }
    }

    unsubscribe(kpi, appId) {
        const key = { kpi, appId };
        for (const sub of this.subscriptions) {
            if (sub.kpi === kpi && sub.appId === appId) {
                this.subscriptions.delete(sub);
            }
        }
        if (this.connected) {
            this.socket.emit("kpi:unsubscribe", { kpi, appId });
        }
    }

    cleanup() {
        this.socket?.disconnect();
        this.socket = null;
        this.subscriptions.clear();
    }
}

export default function getKPIController() {
    if (!instance) {
        instance = new KPIRealtimeController();
        instance.initialize();
    }
    return instance;
}
